// src/queryClient.js
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err) => {
        const code = err?.code;

        // ❌ nunca retry
        if (code === "offline") return false;
        if (code === "unauthorized") return false;

        // ⚠️ backend fora / timeout => 1 retry
        if (code === "backend_down" || code === "timeout") {
          return failureCount < 1;
        }

        // outros => 1 retry
        return failureCount < 1;
      },

      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: false,
      staleTime: 60_000,
      gcTime: 30 * 60_000,
    },

    // (opcional mas recomendado)
    mutations: {
      retry: (failureCount, err) => {
        const code = err?.code;
        if (code === "offline") return false;
        if (code === "unauthorized") return false;
        return false; // conservador: sem retry em mutation
      },
    },
  },
});